export default __webpack_public_path__ + "static/study-2-mobile-b658b64f53551880395de770b3ec9da3.jpg";